export const resetState = () => ({
  type: "RESET_STATE",
});
